import React, { Component } from 'react';
import "./style.scss";

// imports components
import TopNavbar from "../Topnavbar";
import GameList from "../GameList";

class List extends Component {
  render() {
    return (
      <div className="List-container">
        <TopNavbar />
        <GameList />
      </div>
    );
  }
}

export default List;